'use strict';

module.exports = {
  hits: require('./hits.js'),
  popularIn: require('./popularIn.js')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/autocomplete.js/src/sources/index.js
// module id = 61
// module chunks = 0